import api from '../api';

const DEFAULT_COLOR = '#03c9ff';
const colorFormat = function (color = '') {
    try {
        var m = color.match(/^(#[a-f0-9]{6})/i);
        if (m) {
            return m[1];
        } else if (color.startsWith('#') && color.length === 4) {
            return color.replace(/[a-f0-9]/g, `$&0`);
        } else {
            m = color.match(/\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,?\s*/);
            return `#${(+m[1]).toString(16).padEnd(2, '0')}${(+m[2])
                .toString(16)
                .padEnd(2, '0')}${(+m[3]).toString(16).padEnd(2, '0')}`;
        }
    } catch (e) {
        console.error('colorFormat error', e, color);
        return DEFAULT_COLOR;
    }
};

export default {
    // 初始化facebook chat, 返回chat组件
    createIns: function (config, _siteAppVm) {
        if (config.isMobile) {
            return Promise.resolve();
        }
        return api
            .getAgentInfo(config.agentId)
            .catch(e => {
                console.error(e);
            })
            .then(res => {
                // 获取agent消息,保存到config
                config.agent = (res && res.data.agent) || {};
                // var ChatModule = window.SiteVue.extend(App);
                // return new ChatModule({
                //     propsData: {
                //         config: config
                //     }
                // });

                // Load Facebook SDK for JavaScript
                let fb_div = document.createElement('div');
                fb_div.id = 'fb-root';
                document.body.appendChild(fb_div);
                window.fbAsyncInit = function () {
                    window.FB.init({
                        xfbml: true,
                        version: 'v9.0'
                    });
                };
                (function (d, s, id) {
                    var js,
                        fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src =
                        'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
                    fjs.parentNode.insertBefore(js, fjs);
                })(document, 'script', 'facebook-jssdk');
                // customer chat
                let chat_div = document.createElement('div');
                chat_div.className = 'fb-customerchat';
                chat_div.setAttribute('attribution', 'install_email');
                chat_div.setAttribute('page_id', config.pageId);
                chat_div.setAttribute(
                    'theme_color',
                    colorFormat(config.facebookThemeColor || DEFAULT_COLOR)
                );
                chat_div.setAttribute(
                    'logged_in_greeting',
                    config.loggedInGreeting || ''
                );
                chat_div.setAttribute(
                    'logged_out_greeting',
                    config.loggedOutGreeting || ''
                );
                document.body.appendChild(chat_div);
            });
    }
};

/**
    // Load Facebook SDK for JavaScript
    let fb_div = document.createElement('div');
    fb_div.id = 'fb-root';
    document.body.appendChild(fb_div);
    fb_div = null;
    window.fbAsyncInit = function () {
        FB.init({
        xfbml: true,
        version: 'v9.0'
        });
    };
    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if(d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    // customer chat
    let chat_div = document.createElement('div');
    chat_div.className = 'fb-customerchat';
    chat_div.setAttribute('attribution', 'install_email');
    chat_div.setAttribute('page_id', '688393224568077');
    document.body.appendChild(chat_div)
    chat_div = null;
 */
